import { PermissionObjectType } from '@/interfaces/permissionObjectType';
import { EntityResource } from './entity.resource';

/**
 * Resource uprawnień
 *
 * @export
 * @class PermissionResource
 * @extends {EntityResource<PermissionObjectType>}
 */
export class PermissionResource extends EntityResource<PermissionObjectType> {
  public getFields = {
    id: true,
    name: true
  };

  public listFields = {
    id: true,
    name: true
  };

  constructor() {
    super({
      entityName: 'permission',
      listName: 'permissions'
    });
  }
}

export const permissionResource = new PermissionResource();
